import { cubicOut } from "svelte/easing";
import type { TransitionConfig } from "svelte/transition";

// Reflow-free slide for the full page backdrop. Unlike svelte/transition's fly it skips the
// getComputedStyle read that forces a reflow as the DOM mutates, a big cost on mobile.

// Slides a layer horizontally by x pixels. u runs 1 to 0 on intro and 0 to 1 on outro, so the layer
// starts offset by x and settles at 0 coming in, and reverses going out.
export function slidePage(_node: Element, { x, duration }: { x: number; duration: number }): TransitionConfig {
	return {
		duration,
		easing: cubicOut,
		css: (_t, u) => `transform: translate3d(${u * x}px, 0, 0)`,
	};
}
